import { QuestionStayableDayOfTheWeek as Question } from "@/components/features/items/edit/_shared/ui/components/main/questions/stayable-day-of-the-week/stayable-day-of-the-week";

import { useOptionStayableDayOfTheWeek } from "./hooks";

export const QuestionStayableDayOfTheWeek = () => {
	const {
		stayableDayOfTheWeek,
		stayableDayOfTheWeekOptions,
		rawStayableDayOfTheWeek,
		onSetStayableDayOfTheWeek,
		isHolidayStayable,
		onSetIsHolidayStayable,
	} = useOptionStayableDayOfTheWeek();

	const title = "販売可能な曜日";
	const guide =
		"特定の曜日のみで販売する設定が可能です。<br />チェックを外した曜日の在庫は0になります。<br />こちらの設定は在庫設定で上書き可能です。";

	return (
		<Question
			title={title}
			guide={guide}
			stayableDayOfTheWeek={stayableDayOfTheWeek}
			stayableDayOfTheWeekOptions={stayableDayOfTheWeekOptions}
			rawStayableDayOfTheWeek={rawStayableDayOfTheWeek}
			onSetStayableDayOfTheWeek={onSetStayableDayOfTheWeek}
			holidayCopyVariant="sales"
			isHolidayStayable={isHolidayStayable}
			onSetIsHolidayStayable={onSetIsHolidayStayable}
		/>
	);
};

QuestionStayableDayOfTheWeek.displayName = "QuestionStayableDayOfTheWeek";
